import { render, staticRenderFns } from "./TitulosProblematicos.vue?vue&type=template&id=380ecb35"
import script from "./TitulosProblematicos.vue?vue&type=script&lang=js"
export * from "./TitulosProblematicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports